import { render, staticRenderFns } from "./addAndModify.vue?vue&type=template&id=b27c96a6&"
import script from "./addAndModify.vue?vue&type=script&lang=js&"
export * from "./addAndModify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports